<template>
  <div class="bordered">

    <div class="container-fill" @click="toggle">
      <div>
        <b>{{ remediation.title }}</b>
        <div  v-show="!isRem">
          <font color="red" v-show="isPast">
            <b>Ready to Exploit:  </b>{{ remediation.ready_to_exploit }}
          </font>
          <div v-show="!isPast">
            <b>Ready to Exploit:  </b>{{ remediation.ready_to_exploit }}
          </div>
        </div>
        <div  v-show="isRem">          
            <b>Remediated:  </b>{{ remediation.remediated }}         
            <b>Username:  </b>{{ remediation.username }}     
        </div>
      </div>
      <div>{{ remediation.name }} <span class="default" v-show="remediation.default">(default)</span></div>
      
        
        (alerts: {{ remediation.total_alerts }}, risk: {{ remediation.total_risk }})
      
    </div>

    <div class="details" v-show="isActive">
      <!--<div id="profileButtons" v-show="!remediation.default">
        <font-awesome-icon icon="trash" @click="deleteProfile()" title="Delete profile"/>
      </div>-->
      <table v-show="!isRem">        
        <!--<tr>
          <td>Alert_IDs:</td>
          <td>{{ remediation.alert_ids }}</td>
        </tr>
        <tr v-show="remediation.id">
          <td>Remidiated:</td>
          <td>{{remediation.remediated}}</td>
        </tr>-->
        <tr>
          <td>Username:</td>
          <td><input type="text" v-model="username"/></td>
        </tr>
      </table>
      <button @click="cancel()">Cancel</button>
      <button @click="remidiate()" v-show="!isRem">Remidiate</button>
      <button @click="remove()" v-show="isRem">Remove</button>
    </div>
      
    <pre class="debug" v-show="debugMode">{{remediation}}</pre>
    
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#profileButtons {
  display: inline-block;
  float: right;
}
.default {
  font-size: small;
}
.container {
  display: flex;
}
.container-fill {
  display: flex;
  justify-content: space-between;
}
.details {
  margin-top: 5px;
  border-top: 1px solid #cccccc;
  padding-top: 5px;
}
.details-header {
  font-size: small;
}
.details-header > h2,h3,h4 {
  font-size: initial;
  margin: 0px;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    remediation: {
      type: Object,
      required: true
    }
  },
  computed: {
    isPast () {
      //Get current datetime
      var today = new Date()
      var expdate = new Date(this.remediation.ready_to_exploit)       
      //this.remediation.ready_to_exploit = "2020-12-24T00:00:00"
      if(this.remediation.ready_to_exploit == null){
        return false
      }
      else if(today.getTime()>expdate.getTime()) {  
        return true
      }    
      else{
        return false
      }
    },
    isRem () {
      //return this.remediation.id != null
      return this.remediation.username != null
    },
    ...mapState([
      'debugMode'
    ])
  },
  data () {
    return {             
          isActive: false,
          username: this.remediation.username
          //profileName: this.profile.name      
        }      
    
  },  
  methods: {
    toggle: function (event) {
      if (event.target.tagName != 'DIV' && event.target.tagName != 'SPAN') return
      this.isActive = !this.isActive
    },
    cancel () {
      //TODO : Cancel
    },
    remidiate () {
        if (!confirm('Are you sure you want to mark this as remedied?')) return
        if(this.isPast){
          var params = {
            type: this.remediation.type,
            username: this.username
          }        
        }
        else { //Only send alertIds if ready to exploit is not past
          var alertIds = this.remediation.alert_ids.join()
          // eslint-disable-next-line
          var params = {
            type: this.remediation.type,
            alerts: alertIds,
            username: this.username
          }  
        }
        //Get username from textbox
        this.remediation.username = this.username
        //Call API to update
        this.$store.dispatch('createRemediation', {
          profile: this.profile, 
          params: params,
          remediation: this.remediation
        })
    },
    remove(){
        if (!confirm('Are you sure you want to remove this remediation?')) return
        // eslint-disable-next-line
        console.log('removeRemediation',this.remediation)              
        //Call API to update
        this.$store.dispatch('removeRemediation', this.remediation)        
    }    
  }
}
</script>
